//
import {
  CREDENCIALES_LISTA_CREDENCIALES,
  CREDENCIALES_LISTA_CREDENCIALES_SUCCESS,
  CREDENCIALES_LISTA_CREDENCIALES_FAIL,
  CREDENCIALES_UNSET_LISTA_CREDENCIALES,
  CREDENCIALES_LOGOUT,
} from "./actionTypes"

export const CredencialesUnsetListaCredenciales = jsonparameters => {
  return {
    type: CREDENCIALES_UNSET_LISTA_CREDENCIALES,
    payload: { jsonparameters },
  }
}

export const getCredencialesListaCredenciales = jsonparameters => {
  //console.log("jsonparameters: ", jsonparameters)
  return {
    type: CREDENCIALES_LISTA_CREDENCIALES,
    payload: { jsonparameters },
  }
}

export const getCredencialesListaCredencialesSuccess = data => ({
  type: CREDENCIALES_LISTA_CREDENCIALES_SUCCESS,
  payload: { data },
})

export const getCredencialesListaCredencialesFail = error => ({
  type: CREDENCIALES_LISTA_CREDENCIALES_FAIL,
  payload: error,
})

export const SetCredencialesLogout = () => {
  console.log("export const SetCredencialesLogout")
  return {
    type: CREDENCIALES_LOGOUT,
  }
}
